import React, { useEffect, useState } from 'react';
import {
  SiVuedotjs, SiReact, SiAngular, SiJavascript, SiTypescript, SiNuxtdotjs,
  SiNextdotjs, SiBootstrap, SiTailwindcss, SiFigma, SiAdobexd, SiSketch,
  SiNodeDotJs, SiExpress, SiMongodb, SiMysql, SiPostgresql, SiFirebase,
  SiAndroid, SiApple, SiFlutter, SiDart, SiMagento, SiShopify, SiWoocommerce,
  SiWordpress, SiJenkins, SiDocker, SiKubernetes, SiAmazonaws, SiGooglecloud,
  SiMicrosoftazure, SiGraphql, SiMongoose
} from 'react-icons/si';
import { FaAws } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import { categories, techStacks } from '../../../../data/LandingSectionData/techStackData';
import TechCard from '../../../../Components/TechCard';


const MentalHealthTechSolutions = () => {

   const [activeCategory, setActiveCategory] = useState('Frontend');
  
  useEffect(() => {
    AOS.init({ once: false });
  }, []);
  
  useEffect(() => {
    AOS.refresh(); // Refresh AOS when activeCategory changes
  }, [activeCategory]);
  
    return (
      <section className="bg-bgDefault text-white px-4 py-12 lg:py-16 lg:px-36 overflow-x-hidden ">
        <div className="container xl:mx-auto xl:max-w-screen-xl ">
          <div className="lg:text-center text-left mb-10">
            <h2 className="font-dmsans font-bold text-[35px] leading-[43px] tracking-[-6%] lg:text-[60px] lg:leading-[100%]">
             Tech Stack Used
            </h2>
          </div>
  
          {/* Tabs */}
          <div className="flex flex-nowrap sm:flex-wrap overflow-x-auto sm:overflow-visible justify-start sm:justify-center lg:gap-3 gap-2 mb-10 py-2 lg:p-0">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
             className={`whitespace-nowrap px-6 py-2 text-body-sm transition-all duration-200 font-medium text-center transform
              hover:scale-105 active:scale-95 active:shadow-inner rounded-3xl
              ${
                activeCategory === category
                  ? 'border border-[#00E599] text-[#FFFFFF] bg-gradient-to-r from-[#00281B] to-[#008E5F]  lg:text-lg font-dmsans font-medium leading-snug text-body'
                  : 'lg:text-lg text-[#9E9E9E] font-dmsans font-medium leading-snug text-body hover:text-[#FFFFFF]'
              }`}
            >
              {category}
            </button>
          ))}
        </div>
  
          {/* Tech Stack Grid */}
          <div
          className="grid grid-cols-2 gap-4 sm:flex sm:flex-wrap sm:justify-center sm:gap-4 lg:px-24 xl:px-24
            max-h-[400px] overflow-y-auto sm:overflow-visible"
          data-aos="fade-up"
          data-aos-easing="linear"
          data-aos-duration="1000"
           key={activeCategory}
        >
           {(techStacks[activeCategory] || []).map((tech, index) => (
              <TechCard key={index} icon={tech.icon} name={tech.name} />
            ))}
          </div>
        </div>
      </section>
    );
  };

export default MentalHealthTechSolutions;
